import * as m from '~/paraglide/messages'
import { createFieldValidators } from '~/shared/lib/form-utils'
import { updateContactSchema } from '~/shared/types'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/shared/ui/card'
import { FormInput } from '~/shared/ui/form'

interface ContactInfoSectionProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form API is dynamically typed
  form: any
}

export function ContactInfoSection({ form }: ContactInfoSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{m.contactInformation()}</CardTitle>
        <CardDescription>{m.updateHowCustomersCanReachYou()}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <form.Field
          name="email"
          validators={createFieldValidators(updateContactSchema.shape.email)}
        >
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => <FormInput field={field} label={m.email()} type="email" />}
        </form.Field>

        <form.Field
          name="phone"
          validators={createFieldValidators(updateContactSchema.shape.phone)}
        >
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => <FormInput field={field} label={m.phone()} type="tel" />}
        </form.Field>

        <form.Field
          name="website"
          validators={createFieldValidators(updateContactSchema.shape.website)}
        >
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <FormInput
              field={field}
              label={m.website()}
              type="url"
              placeholder={m.httpswwwyourbusinesscom()}
              optional
            />
          )}
        </form.Field>
      </CardContent>
    </Card>
  )
}
